import React, { useState, useEffect, useCallback, useRef } from "react";
import useAppContext from "../../../utils/Reducers";
import ButtonBar from "../../../components/Layout/ButtonBar";
import SearchBar from "./SearchBar";
import { useAxiosWithAuthorization } from "../../../utils/api";
import SelectBox from "../../../components/SelectBox";
import { ModalConfirm } from "../../../components/Confirm";
import { gridColumnLayOut } from "./columnLayout";
import { defaultGridProps } from "../../../components/AuiGrid/gridLayout";
import {
  setStorageItem,
  getStorageItem,
} from "../../../hooks/Storage/useLocalStorage";
import AUIGrid from "../../../lib/AuiGrid/AUIGridReact";
import moment from "moment";
import {isFieldDisabled} from "../../../utils/validators";

const GradeCancelReg = (props) => {
  const myGrid = useRef();

  const gridProps = {
    ...defaultGridProps,
    width: "99%",
    height: 600,
  };
  const {
    store: { userInfo, menuKey },
  } = useAppContext();

  useEffect(() => {
    const auiGrid = myGrid.current;
    auiGrid.resize("100%", 600);
  }, [menuKey]);

  const [primaryParameters, setPrimaryParameters] = useState({
    schPlantCd: "",
    schScrapAreaCd: "",
    schVndrNm: "",
    schSinspDt: moment().format("YYYY-MM-DD"),
    schEinspDt: moment().format("YYYY-MM-DD"),
  });

  const [state, setState] = useState("updated");

  //추가, 수정일때 항목의 disabled 결정
  const disabledFields = {
    created: [""],
    updated: ["systemCd"],
  };

  const initItem = {
    inspNo: "",
    inspDt: "",
    inspCd: "",
    plantCd: "",
    transCd: "",
    vhclNo: "",
    vhclType: "",
    itemCd: "",
    vndrCd: "",
    vndrNm: "",
    rvndrCd: "",
    rvndrNm: "",
    loadAreaCd: "",
    loadAreaNm: "",
    scrapAreaCd: "",
    scrapAreaNm: "",
    magnet: "",
    dcsnItemCd: "",
    subItemCd1: "",
    subItemPrdCd1: "",
    subItemRate1: "",
    subItemCd2: "",
    subItemPrdCd2: "",
    subItemRate2: "",
    subItemCd3: "",
    subItemPrdCd3: "",
    subItemRate3: "",
    outageCd: "",
    outageWght: "",
    outageRsn: "",
    returnCd: "",
    returnWght: "",
    returnRsn: "",
    dprctCd: "",
    dprctRate: "",
    scalNo: "",
    cnclRsnCd: "",
    cnclRsn: "",
    cancelYn: "N",
    updateYn: "N",
    tmsOdrno: "",
    workerId: "",
    workerNm: "",
    rmks: "",
  };

  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    const auiGrid = myGrid.current;
    auiGrid.create(gridColumnLayOut, { ...defaultGridProps });

    auiGrid.bind("cellClick", function (event) {
      gridCellClick(event.item);
    });

    auiGrid.bind("keyDown", function (event) {
      if (event.keyCode === 38 || event.keyCode === 40) {
        var selectedItems = auiGrid.getSelectedItems(event.pid);
        // 엔터 키
        //console.log(selectedItems[0]);
        gridCellClick(selectedItems[0].item);
      }
    });

    //Local Storage에 저장된 그리드 컬럼 정렬정보를 가져옴
    const columnList = getStorageItem(props.menuInfo.menuId, "");
    if (columnList !== "") {
      auiGrid.setColumnOrder(columnList);
    }
    const columnSize = getStorageItem(props.menuInfo.menuId + "_s", "");
    if (columnSize !== "") {
      //Local Storage에 저장된 그리드 컬럼 Width 정보를 가져옴
      auiGrid.setColumnSizeList(columnSize);
    }
  }, []);

  const [fieldValues, setFieldValues] = useState(initItem);

  const SEARCH_INSPECTION_CONFIRM_URL =
    "/inspection/confirm/searchInspectionConfirmList.do";

  const SAVE_INSPECTION_CANCEL_URL =
    "/inspection/confirm/saveInspectionCancel.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SEARCH_INSPECTION_CONFIRM_URL,
    },
    { manual: true }
  );

  const gridCellClick = (item) => {
    //그리드 셀을 클릭했을 때 데이터 상태
    // 추가 : editable, 수정 : edtiable, 삭제 : readonly
    //read
    //setFieldsEnabled(auiGrid, item, disabledFields);
    if (item.inspCd === "S") {
      setState("normaled");
    } else if (item.inspCd === "R") {
      setState("updated");
    } else if (item.inspCd === "C") {
      setState("updated");
    }

    var reItem = initItem;
    reItem = item;
    //console.log(reItem);
    setFieldValues(reItem);
    const auiGrid = myGrid.current;
    auiGrid.addCheckedRowsByIds(item);
  };

  const updateInspectionConfirm = async () => {
    if (
      await ModalConfirm({
        title: "검수수정",
        description: "검수정보를 수정하시겠습니까?",
      })
    ) {
      const {
        data: { data },
      } = await fetchData({
        url: SAVE_INSPECTION_CANCEL_URL,
        data: {
          status: "U",
          ...fieldValues,
        },
        method: "POST",
      });
      handleMasterSearch();
    }
  };

  const handleChangeField = useCallback((event) => {
    //console.log(fieldValues);
    const { name, value } = event.target;
    setFieldValues({
      ...fieldValues,
      [name]: value,
    });
  });

  //그리드 정렬 저장
  const handleGridSorting = useCallback(() => {
    const auiGrid = myGrid.current;
    const items = auiGrid.getColumnInfoList();
    let columnList = [];
    let columnSize = [];
    items.forEach((item) => {
      columnList.push(item.dataField);
      columnSize.push(item.width);
    });
    setStorageItem(props.menuInfo.menuId, columnList);
    setStorageItem(props.menuInfo.menuId + "_s", columnSize);
    ModalConfirm({
      title: "그리드 정렬 저장",
      description: "그리드 정렬을 저장하였습니다. ",
    });
  });

  const handleMasterExcel = useCallback(() => {
    const auiGrid = myGrid.current;
    auiGrid.exportToXlsx({
      fileName: props.menuInfo.menuNmKor + " 리스트",
      exceptColumnFields: auiGrid.getHiddenColumnDataFields(),
    });
  });

  const handleMasterSearch = async () => {
    const auiGrid = myGrid.current;
    auiGrid.showAjaxLoader();
    const {
      data: { data },
    } = await fetchData({
      url: SEARCH_INSPECTION_CONFIRM_URL,
      params: primaryParameters,
    });
    auiGrid.setGridData(data);
    setFieldValues(initItem);
    auiGrid.removeAjaxLoader();
    setState("normaled");
  };

  //그리드 정렬 취소
  const handleGridSortingCancel = useCallback(() => {
    const auiGrid = myGrid.current;
    setStorageItem(props.menuInfo.menuId, "");
    var colLayout = gridColumnLayOut;
    auiGrid.changeColumnLayout(colLayout);
    ModalConfirm({
      title: "그리드 정렬 취소",
      description: "그리드 정렬을 취소하였습니다. ",
    });
  });
  const handleInspectionConfirm = async () => {
    if (
      await ModalConfirm({
        title: "검수확정",
        description: "검수확정하시겠습니까?",
      })
    ) {
      let item = fieldValues;
      let totalRate =
        fieldValues.subItemRate1 !== ""
          ? parseInt(fieldValues.subItemRate1)
          : 0 + fieldValues.subItemRate2 !== ""
          ? parseInt(fieldValues.subItemRate2)
          : 0 + fieldValues.subItemRate3 !== ""
          ? parseInt(fieldValues.subItemRate3)
          : 0;
      //console.log(totalRate);
      if (totalRate !== 100) {
        ModalConfirm({
          title: "비율합계 오류",
          description: "세부품목비율 합계가 100%가 아닙니다. 다시 입력하세요..",
        });
        return;
      }

      item.status = "U";
      item.inspCd = "S";
      const {
        data: { data },
      } = await fetchData({
        url: SAVE_INSPECTION_CANCEL_URL,
        data: item,
        method: "POST",
      });
      handleMasterSearch();
    }
  };

  return (
    <>
      <ButtonBar
        menuInfo={props.menuInfo}
        handleMasterSearch={handleMasterSearch}
        handleMasterExcel={handleMasterExcel}
        isGridSort={true}
        handleGridSorting={handleGridSorting}
        handleGridSortingCancel={handleGridSortingCancel}
      />
      <SearchBar
        primaryParameters={primaryParameters}
        setPrimaryParameters={setPrimaryParameters}
      />

      <div className="flexible_contents_box3">
        <div className="databox cctv_half">
          <div className="tabbox" id="mTabContents">
            <div style={{ width: "100%", height: "100%" }}>
              <AUIGrid
                ref={myGrid}
                columnLayout={gridColumnLayOut}
                gridProps={gridProps}
              />
            </div>
          </div>
        </div>
        <div className="databox">
          <div className="subdatabox">
            <div id="mTableTab">
              <div className="table_list on">
                <ul className="t_form">
                  <li className="half">
                    <div className="title">운송구분</div>
                    <div className="formbox">
                      <SelectBox
                        mastCd="TRANS_CD"
                        id="transCd"
                        name="transCd"
                        disabled={true}
                        topSelected="선택"
                        value={fieldValues.transCd}
                        className="ip2"
                      />
                    </div>
                  </li>
                  <li className="half">
                    <div className="title">사전등급</div>
                    <div className="formbox">
                      <SelectBox
                        mastCd="ITEM_CD"
                        id="itemCd"
                        name="itemCd"
                        disabled={true}
                        topSelected="선택"
                        value={fieldValues.itemCd}
                        className="ip2"
                      />
                    </div>
                  </li>
                  <li className="">
                    <div className="title">차량번호</div>
                    <div className="ip_sup3">
                      <div>
                        <input
                          type="text"
                          id="vhclNo"
                          name="vhclNo"
                          disabled={true}
                          value={fieldValues.vhclNo}
                          className="ip2"
                        />
                      </div>
                      <div>
                        <SelectBox
                          mastCd="VHCL_TYPE"
                          id="vhclType"
                          name="vhclType"
                          topSelected="선택"
                          disabled={true}
                          onChange={handleChangeField}
                          value={fieldValues.vhclType}
                          className="ip2"
                        />
                      </div>
                    </div>
                  </li>
                  <li className="half">
                    <div className="title">공급업체</div>
                    <div className="formbox">
                      <input
                        type="text"
                        id="vndrNm"
                        name="vndrNm"
                        disabled={true}
                        value={fieldValues.vndrNm}
                        className="ip2"
                      />
                    </div>
                  </li>
                  <li className="half">
                    <div className="title2">실공급업체</div>
                    <div className="formbox">
                      <input
                        type="text"
                        id="rvndrNm"
                        name="rvndrNm"
                        disabled={true}
                        value={fieldValues.rvndrNm}
                        className="ip2"
                      />
                    </div>
                  </li>
                  <li className="half">
                    <div className="title">하차지</div>
                    <div className="formbox">
                      <div>
                        <SelectBox
                          mastCd="SCRAP_AREA_CD"
                          id="scrapAreaCd"
                          name="scrapAreaCd"
                          topSelected="선택"
                          disabled={true}
                          onChange={handleChangeField}
                          value={fieldValues.scrapAreaCd}
                          className="ip2"
                        />
                      </div>
                    </div>
                  </li>
                  <li className="half">
                    <div className="title2">검수원</div>
                    <div className="formbox">
                      <div>
                        <input
                          type="text"
                          id="workNm"
                          name="workNm"
                          disabled={true}
                          value={fieldValues.workerNm}
                          className="ip2"
                        />
                      </div>
                    </div>
                  </li>
                  <li className="">
                    <div className="title">검수등급</div>
                    <div className="formbox">
                      <SelectBox
                        mastCd="ITEM_CD"
                        id="dcsnItemCd"
                        name="dcsnItemCd"
                        topSelected="선택"
                        disabled={true}
                        onChange={handleChangeField}
                        value={fieldValues.dcsnItemCd}
                        className="ip2"
                      />
                    </div>
                  </li>
                </ul>
                <table className="t_greyth">
                  <tr>
                    <th>등급</th>
                    <th>품목</th>
                    <th>비율</th>
                  </tr>
                  <tr className="t_slider">
                    <td>
                      <SelectBox
                        mastCd="ITEM_CD"
                        id="subItemCd1"
                        name="subItemCd1"
                        disabled={true}
                        topSelected="선택"
                        onChange={handleChangeField}
                        value={
                          fieldValues.subItemCd1 !== null
                            ? fieldValues.subItemCd1
                            : ""
                        }
                        className="ip2"
                      />
                    </td>
                    <td>
                      <SelectBox
                        mastCd="ITEM_PRD_CD"
                        id="subItemPrdCd1"
                        name="subItemPrdCd1"
                        disabled={true}
                        topSelected="선택"
                        onChange={handleChangeField}
                        attr1={fieldValues.subItemCd1}
                        value={
                          fieldValues.subItemPrdCd1 !== null
                            ? fieldValues.subItemPrdCd1
                            : ""
                        }
                        className="ip2"
                      />
                    </td>
                    <td>
                     {/* <SelectBox
                        mastCd="ITEM_RATE"
                        id="subItemRate1"
                        name="subItemRate1"
                        disabled={true}
                        topSelected="선택"
                        onChange={handleChangeField}
                        value={
                          fieldValues.subItemRate1 !== null
                            ? fieldValues.subItemRate1
                            : ""
                        }
                        className="ip2"
                      />*/}
                      <div className="formbox">
                        <input
                            type="text"
                            id="subItemRate1"
                            name="subItemRate1"
                            // style={{ width: "108px;" }}
                            /*                            disabled={isFieldDisabled(
                                                            state,
                                                            "menuNmKor",
                                                            disabledFields
                                                        )}*/
                            onChange={handleChangeField}
                            value={fieldValues.subItemRate1 !== null
                                ? fieldValues.subItemRate1
                                : ""}
                            className="ip2"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr className="t_slider">
                    <td>
                      <SelectBox
                        mastCd="ITEM_CD"
                        id="subItemCd2"
                        name="subItemCd2"
                        disabled={true}
                        topSelected="선택"
                        onChange={handleChangeField}
                        value={
                          fieldValues.subItemCd2 !== null
                            ? fieldValues.subItemCd2
                            : ""
                        }
                        className="ip2"
                      />
                    </td>
                    <td>
                      <SelectBox
                        mastCd="ITEM_PRD_CD"
                        id="subItemPrdCd2"
                        name="subItemPrdCd2"
                        disabled={true}
                        topSelected="선택"
                        onChange={handleChangeField}
                        attr1={fieldValues.subItemCd2}
                        value={
                          fieldValues.subItemPrdCd2 !== null
                            ? fieldValues.subItemPrdCd2
                            : ""
                        }
                        className="ip2"
                      />
                    </td>
                    <td>
                   {/*   <SelectBox
                        mastCd="ITEM_RATE"
                        id="subItemRate2"
                        name="subItemRate2"
                        disabled={true}
                        topSelected="선택"
                        onChange={handleChangeField}
                        value={
                          fieldValues.subItemRate2 !== null
                            ? fieldValues.subItemRate2
                            : ""
                        }
                        className="ip2"
                      />*/}
                      <div className="formbox">
                        <input
                            type="text"
                            id="subItemRate2"
                            name="subItemRate2"
                            // style={{ width: "108px;" }}
                            /*                            disabled={isFieldDisabled(
                                                            state,
                                                            "menuNmKor",
                                                            disabledFields
                                                        )}*/
                            onChange={handleChangeField}
                            value={fieldValues.subItemRate2 !== null
                                ? fieldValues.subItemRate2
                                : ""}
                            className="ip2"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr className="t_slider">
                    <td>
                      <SelectBox
                        mastCd="ITEM_CD"
                        id="subItemCd3"
                        name="subItemCd3"
                        disabled={true}
                        topSelected="선택"
                        onChange={handleChangeField}
                        value={
                          fieldValues.subItemCd3 !== null
                            ? fieldValues.subItemCd3
                            : ""
                        }
                        className="ip2"
                      />
                    </td>
                    <td>
                      <SelectBox
                        mastCd="ITEM_PRD_CD"
                        id="subItemPrdCd3"
                        name="subItemPrdCd3"
                        disabled={true}
                        topSelected="선택"
                        onChange={handleChangeField}
                        attr1={fieldValues.subItemCd3}
                        value={
                          fieldValues.subItemPrdCd3 !== null
                            ? fieldValues.subItemPrdCd3
                            : ""
                        }
                        className="ip2"
                      />
                    </td>
                    <td>
{/*                      <SelectBox
                        mastCd="ITEM_RATE"
                        id="subItemRate3"
                        name="subItemRate3"
                        disabled={true}
                        topSelected="선택"
                        onChange={handleChangeField}
                        value={
                          fieldValues.subItemRate3 !== null
                            ? fieldValues.subItemRate3
                            : ""
                        }
                        className="ip2"
                      />*/}
                      <div className="formbox">
                        <input
                            type="text"
                            id="subItemRate3"
                            name="subItemRate3"
                            // style={{ width: "108px;" }}
                            /*                            disabled={isFieldDisabled(
                                                            state,
                                                            "menuNmKor",
                                                            disabledFields
                                                        )}*/
                            onChange={handleChangeField}
                            value={fieldValues.subItemRate3 !== null
                                ? fieldValues.subItemRate3
                                : ""}
                            className="ip2"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr className="t_slider">
                    <td>
                      <SelectBox
                          mastCd="ITEM_CD"
                          id="etcItemCd"
                          name="etcItemCd"
                          disabled={isFieldDisabled(
                              state,
                              "etcItemCd",
                              disabledFields
                          )}
                          topSelected="선택"
                          onChange={handleChangeField}
                          value={
                            fieldValues.etcItemCd !== null
                                ? fieldValues.etcItemCd
                                : ""
                          }
                          className="ip2"
                      />
                    </td>
                    <td>
                      <SelectBox
                          mastCd="ITEM_PRD_CD"
                          id="etcItemPrdCd"
                          name="etcItemPrdCd"
                          disabled={isFieldDisabled(
                              state,
                              "etcItemPrdCd",
                              disabledFields
                          )}
                          topSelected="선택"
                          onChange={handleChangeField}
                          attr1={fieldValues.etcItemCd}
                          value={
                            fieldValues.etcItemPrdCd !== null
                                ? fieldValues.etcItemPrdCd
                                : ""
                          }
                          className="ip2"
                      />
                    </td>
                    <td>
                      {/*                      <SelectBox
                        mastCd="ITEM_RATE"
                        id="subItemRate3"
                        name="subItemRate3"
                        disabled={isFieldDisabled(
                          state,
                          "subItemRate3",
                          disabledFields
                        )}
                        topSelected="선택"
                        onChange={handleChangeField}
                        value={
                          fieldValues.subItemRate3 !== null
                            ? fieldValues.subItemRate3
                            : ""
                        }
                        className="ip2"
                      />*/}

                      <div className="formbox">
                        <input
                            type="text"
                            id="etcItemRate"
                            name="etcItemRate"
                            // style={{ width: "108px;" }}
                            /*                            disabled={isFieldDisabled(
                                                            state,
                                                            "menuNmKor",
                                                            disabledFields
                                                        )}*/
                            onChange={handleChangeField}
                            value={fieldValues.etcItemRate !== null
                                ? fieldValues.etcItemRate
                                : ""}
                            className="ip2"
                        />
                      </div>
                    </td>
                  </tr>
                </table>
                <ul className="t_form">
                  <li className="half">
                    <div className="title">감량</div>
                    <div className="formbox">
                      <SelectBox
                        mastCd="OUTAGE_WGHT"
                        id="outageWght"
                        name="outageWght"
                        topSelected="선택"
                        disabled={true}
                        onChange={handleChangeField}
                        value={
                          fieldValues.outageWght !== null
                            ? fieldValues.outageWght
                            : ""
                        }
                        className="ip2"
                      />
                    </div>
                  </li>
                  <li className="half">
                    <div className="title">사유</div>
                    <div className="formbox">
                      <SelectBox
                        mastCd="OUTAGE_CD"
                        id="outageRsn"
                        name="outageRsn"
                        topSelected="선택"
                        disabled={true}
                        onChange={handleChangeField}
                        value={
                          fieldValues.outageRsn !== null
                            ? fieldValues.outageRsn
                            : ""
                        }
                        className="ip2"
                      />
                    </div>
                  </li>
                  <li className="half">
                    <div className="title">반품/경고</div>
                    <div className="formbox">
                      <SelectBox
                        mastCd="RETURN_CD"
                        id="returnCd"
                        name="returnCd"
                        topSelected="선택"
                        disabled={true}
                        onChange={handleChangeField}
                        value={
                          fieldValues.returnCd !== null
                            ? fieldValues.returnCd
                            : ""
                        }
                        className="ip2"
                      />
                    </div>
                  </li>
                  <li className="half">
                    <div className="title">사유</div>
                    <div className="formbox">
                      <SelectBox
                        mastCd="OUTAGE_CD"
                        id="returnRsn"
                        name="returnRsn"
                        topSelected="선택"
                        disabled={true}
                        onChange={handleChangeField}
                        value={
                          fieldValues.returnRsn !== null
                            ? fieldValues.returnRsn
                            : ""
                        }
                        className="ip2"
                      />
                    </div>
                  </li>
                  <li className="half">
                    <div className="title">감가내역</div>
                    <div className="formbox">
                      <SelectBox
                        mastCd="DPRCT_CD"
                        id="dprctCd"
                        name="dprctCd"
                        topSelected="선택"
                        disabled={true}
                        onChange={handleChangeField}
                        value={
                          fieldValues.dprctCd !== null
                            ? fieldValues.dprctCd
                            : ""
                        }
                        className="ip2"
                      />
                    </div>
                  </li>
                  <li className="half">
                    <div className="title">감가비율</div>
                    <div className="formbox">
                      <SelectBox
                        mastCd="ITEM_RATE"
                        id="dprctRate"
                        name="dprctRate"
                        disabled={true}
                        topSelected="선택"
                        onChange={handleChangeField}
                        value={
                          fieldValues.dprctRate !== null
                            ? fieldValues.dprctRate
                            : ""
                        }
                        className="ip2"
                      />
                    </div>
                  </li>
                </ul>
                <ul className="t_form">
                  <li className="half">
                    <div className="title">취소사유</div>
                    <div className="formbox">
                      <SelectBox
                        mastCd="CNCL_RSN_CD"
                        id="cnclRsnCd"
                        name="cnclRsnCd"
                        topSelected="선택"
                        disabled={fieldValues.updateYn === "N" ? true : false}
                        onChange={handleChangeField}
                        value={
                          fieldValues.cnclRsnCd !== null
                            ? fieldValues.cnclRsnCd
                            : ""
                        }
                        className="ip2"
                      />
                    </div>
                    <div className="formbox">
                      <input
                        type="text"
                        id="cnclRsn"
                        name="cnclRsn"
                        disabled={fieldValues.updateYn === "N" ? true : false}
                        value={fieldValues.cnclRsn}
                        onChange={handleChangeField}
                        className="ip2"
                      />
                    </div>
                  </li>
                </ul>
                {fieldValues && (
                  <>
                    {fieldValues.updateYn === "Y" ? (
                      <>
                        <button
                          style={{
                            width: "100%",
                            height: "80px",
                            borderRadius: "10px",
                          }}
                          className="btn_greystyle"
                          onClick={updateInspectionConfirm}
                        >
                          검수확정취소
                        </button>
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GradeCancelReg;
